<template>
    <div>
        <b-card no-body class="p-0">
            <accordion 
                v-for="aba in abas" 
                :key="aba.titulo"
                :id="aba.componente" 
                :title="aba.titulo"
                sub
                accordion="sub_caracteristicas"
                :projeto-editavel="projetoEditavel">
                <component :is='aba.componente' 
                    @salvar="salvar($event, aba)" 
                    :ref="aba.componente" 
                    :objeto="aba.objeto"
                    :projeto-editavel="projetoEditavel"
                />
                
            </accordion>
        </b-card>
    </div>
</template>
<script>
import ProjetoService from "@/common/services/projeto/projeto.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

import Accordion from '@/components/card/Accordion';

export default {
    mixins: [AlertasMixin],
    props: {
        projetoIdBase : {
            required : true,
        },   
          projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        'produto-principal': () => import('./componentes/ProdutoPrincipal.vue'),
        'tecnica-empregada': () => import('./componentes/TecnicaEmpregada.vue'),
        'aplicabilidade-prevista': () => import('./componentes/AplicabilidadePrevista.vue'),
        'transferencia-tecnologica': () => import('./componentes/TransferenciaTecnologica.vue'),
        Accordion,
    },
    data : () =>({
        abas : [],
    }),

    methods : {
        criarAbas : function(){
            this.abas = [  
                {
                    titulo : "Produto principal",
                    componente : "produto-principal",
                    objeto : {},
                },
                {
                    titulo : "Técnica empregada",
                    componente : "tecnica-empregada",
                    objeto : {},
                },
                {
                    titulo : "Aplicabilidade prevista",
                    componente : "aplicabilidade-prevista",
                    objeto : {},
                },
                {
                    titulo : "Transferência tecnológica",
                    componente : "transferencia-tecnologica",
                    objeto : {},
                },

            ]

            this.buscarAbas(null);
        },

        buscarAbas : function(aba){
            this.abas.filter(el => {
                return (aba ? el.componente == aba : true);
            }).forEach(element => {
                ProjetoService.listarCaracteristicas(element.componente,this.projetoIdBase).then(response => {
                    element.objeto = response.data.data;
                });
            });
        },

        salvar : function(form, aba, mensagemConfirmacao = "Deseja salvar?", mensagemSucesso = "Salvo com sucesso!"){
           
           if(!this.$refs[aba.componente][0].validateState())
                return;

            
            if(form.arquivoObrigatorio){
                
                for (let index = 0; index < form.arquivoObrigatorio.length; index++) {
                    
                    if(!form[form.arquivoObrigatorio[index].campo]){
                        this.alertaErro(`Campo ${form.arquivoObrigatorio[index].nomeCampo} é obrigatório!`);
                        return;
                    }
                }
            }

            this.confirmar(mensagemConfirmacao,"").then(confirmado => {
                if(confirmado){
                    form.ProjetoId = this.projetoIdBase;
                    ProjetoService.atualizarCaracteristicas(aba.componente, form).then(() => {
                        this.alertaSucesso(mensagemSucesso);
                        this.buscarAbas(aba.componente);
                        this.$emit('update')
                    }).catch(err => {
                        if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    });
                }
            });
        },

    },

    mounted : function(){
        this.criarAbas();
    }
}
</script>
<style>
    .aneel .nav-item {
        border-bottom: 1px solid #e5e5e5;
    }
</style>